var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"typewriter"},[_c('div',{ref:"slot"},[_vm._t("default")],2),_c('div',{staticClass:"typewriter",class:{ 'writing': _vm.showCursorInt && _vm.showCursor },style:({ width: `${this.width}px` }),domProps:{"innerHTML":_vm._s(_vm.finalText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }